document.addEventListener('DOMContentLoaded', () => {
  // 1) zrušení blur/odkrytí fotky
  document.addEventListener('click', (e) => {
    const reveal = e.target.closest('.js-show-more');
    if (reveal) {
      const imgWrap = reveal.closest('.photo-carousel__img');
      imgWrap && imgWrap.classList.remove('photo-carousel__img--hidden');
    }
  });

  // 2) přepínání PO ↔︎ před v rámci jedné položky
  document.addEventListener('click', (e) => {
    const label = e.target.closest('.photo-carousel__info span');
    if (!label) return;

    const item = label.closest('.photo-carousel__item');
    if (!item) return;

    const links = item.querySelectorAll('.photo-carousel__img a');
    const img1 = links[0] || null;                       // PO zákroku (default)
    const img2 = links[1] || null;                       // před zákrokem (může chybět)
    if (!img1) return;

    const labels = item.querySelectorAll('.photo-carousel__info span');

    // Klik na první span = „PO zákroku“, poslední = „před zákrokem“
    const clickedIsAfter = (label === labels[0]);
    const showBefore = !clickedIsAfter;

    // Když není „před“ fotka, nic nepřepínej
    if (showBefore && !img2) return;

    // Přepnutí tříd
    if (showBefore) {
      img1.classList.add('hide');
      img2.classList.remove('hide');
    } else {
      img1.classList.remove('hide');
      img2 && img2.classList.add('hide');
    }

    // Aktivní štítek
    labels.forEach(l => l.classList.remove('is-active'));
    label.classList.add('is-active');
  });
});
